export default function isValidURLProtocol(str: string) {
  let url: URL;
  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }
  return ["http:", "https:"].includes(url.protocol);
}
